export default "__VITE_ASSET__DPt91Vl___"